<template lang="pug">
  .TheHeaderUserMenu.header-user-menu.top-bar-user-data(aria-label="Click on user menu")
    UserPicture.header-user-menu__avatar.small-avatar
    SolidSortDownIcon.svg-icon.sort-down-icon.header-user-menu__down-icon
    ul.dropdown-menu
      li.dropdown-menu__user
        span.dropdown-menu__user-name(aria-label="User name") {{ userName }}
      li.dropdown-menu__item(
        v-for="item in menu"
        :key="item.slug"
        :class="`is--${item.slug}`"
      )
        TheHeaderMenuItem.dropdown-menu__item-link(
          :key="item.slug",
          v-bind="item",
        )
      li.dropdown-menu__logout
        a.dropdown-menu__logout-link(
          color="primary",
          @click.prevent="logout"
          href="/"
          aria-label="Click on Logout link"
        )
          | Logout
          ArrowRightFromBracket.svg-icon.dropdown-menu__logout-link-icon
</template>

<script>
import { mapActions } from 'vuex';
import UserPicture from 'Components/UserPicture/UserPicture';
import SolidSortDownIcon from 'images/svg-icons/new-chevron-down.svg?component';
import ArrowRightFromBracket from 'images/svg-icons/arrow-right-from-bracket-2.svg?component';
import TheHeaderMenuItem from './TheHeaderMenuItem';

export default {
  name: 'TheHeaderUserMenu',
  components: {
    UserPicture,
    SolidSortDownIcon,
    ArrowRightFromBracket,
    TheHeaderMenuItem,
  },
  props: {
    isLoginPage: Boolean,
    isSignUpPage: Boolean,
    disabled: Boolean,
    menu: {
      type: Array,
      required: true,
      default: () => [],
    },
    userName: String,
  },
  methods: {
    ...mapActions('login', [
      'logout',
    ]),
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.top-bar-user-data
  display: flex
  position: relative
  padding: 15px 0
  align-items: center
  cursor: pointer
  @media screen and (max-width: 991px)
    display: none
  &:hover
    .dropdown-menu
      visibility: visible
      opacity: 1
      +mt(.2s)
      li
        z-index: 1
        pointer-events: auto
.header-user-menu
  &__down-icon
    margin-left: 4px
    transition: all 0.3s ease-in-out
    position: relative
    top: 2px
    width: 16px
    height: 16px
    fill: $text_gray
  &__avatar
    width: 40px
    height: 40px
    font-size: 20px
    position: relative
    ::v-deep .img
      width: 100%
      height: 100%
    &:not(.is_image)
      box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.05)
      ::v-deep .img
        width: 18px
        height: 18px
.dropdown-menu
  position: absolute
  padding-bottom: 10px
  cursor: pointer
  overflow: hidden
  visibility: hidden
  background-color: #fff
  opacity: 0
  +mt(.1s)
  +elevation(1)
  right: -5px
  top: 67px
  width: 170px
  min-width: max-content
  @media screen and (min-width: 1280px)
    left: 50%
    transform: translate(-50%, 0px)
  @media screen and (max-width: 767px)
    position: relative
    height: 0
    top: 0
  &__item
    &.is--notifications
      display: none
  &__item-link
    height: 40px !important
    font-size: 14px
    +font(500)
    color: $primary
    width: 100%
    display: flex
  &__user
    background-color: $alabaster
    padding: 4px 20px
    display: flex
    margin-bottom: 10px
    text-align: center
    align-items: center
    justify-content: flex-start
  &__user-name
    font-size: 12px
    line-height: 17px
    color: $text_gray
    +font(400)
  &__logout
    display: flex
    border-top: solid 1px $mercury
    margin-top: 10px
    padding-top: 10px
  &__logout-link
    font-size: 14px
    line-height: 20px
    display: flex
    +font(500)
    color: $primary
    padding: 10px 20px
    flex-direction: row
    justify-content: space-between
    align-items: center
    width: 100%
  &__logout-link-icon
    height: 14px
    width: 16px
    fill: $mercury
</style>
